



































import {Component, Vue, Watch} from "vue-property-decorator";
import BaseOverview, {Loadable} from "@/resources/components/BaseOverview.vue";
import Brand from "@/app/models/Brand";
import ProductionOrder from '@/app/models/ProductionOrder';
import Debounce from "@/app/support/Debounce";
import ProgressMixin, { ProgressConfig } from "@/app/mixins/SampleMixin";
import ProgressBar from "@/resources/components/ProgressBar.vue";
import Station from "@/app/models/Station";
@Component({
    components: {BaseOverview, ProgressBar},
    mixins: [ProgressMixin]
})
export default class Brands extends Vue {
    productionOrder: ProductionOrder = new ProductionOrder({});
    search: string = '';
    $refs!: { overview: BaseOverview }

    getProgress!: (total_brands: number) => ProgressConfig;

    get station(): Station|null {
        return this.$store.state.data.station;
    }

    @Watch('search')
    @Debounce(250)
    onSearchUpdated() {
        this.$refs.overview.reset();
    }

    async mounted() {
        this.productionOrder = await ProductionOrder.show(parseInt(this.$route.params.productionOrder)) as ProductionOrder;
    }

    async loadItems(loadable: Loadable) {
        loadable.loadItems(
            (await Brand.index(loadable.page, {
                production_order_id: this.$route.params.productionOrder,
                checklists: true,
                search: this.search,
            })).data
        );
    }
}
